export const hiddenMedalliaButton = () => {
  const hideButton = () => {
    const button = document.querySelector('#nebula_div_btn');
    if (button) {
      button.style.display = 'none';
    }
  };

  hideButton();

  const interval = setInterval(() => {
    const button = document.querySelector('#nebula_div_btn');
    if (button) {
      button.style.display = 'none';
      clearInterval(interval);
    }
  }, 100);

  return () => clearInterval(interval);
};